import { createContext, useContext } from 'react';

type BlocksContextValue = {
  layoutType?: 'basic' | 'section';
  hero?: {
    isHero: boolean;
    heroType: 'media-text' | '';
  };
};

const defaultValue: BlocksContextValue = {
  layoutType: 'section',
  hero: {
    isHero: false,
    heroType: 'media-text',
  },
};

const BlocksContext = createContext<BlocksContextValue>(defaultValue);

export const BlocksProvider = BlocksContext.Provider;

export const useBlocksContext = (): BlocksContextValue =>
  useContext(BlocksContext);
